import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { useAuth } from '../../providers/AuthProvider'
import { config } from '../../config.js'
import { getBillDownload } from '../../dataClient/apiCalls.js'
import { buildBillPdfFileName } from '../../util/billFormatting.js'
import { handleDownloadResponse } from '../../util/downloadFile.js'
import BodyText, { BoldSpan } from '../styles/Text.js'
import { SecondaryButton } from '../common/Button.js'
import { ErrorMessage } from '../common/UserMessage.js'
import ActionRequiredTemplate from '../common/ActionRequiredTemplate.js'

const AddressText = styled(BodyText)`
  white-space: pre-line;
`

function FOIConfirmationAwaitingPayment({ foiSecondaryId, billSecondaryId, billId }) {
  const { authState } = useAuth()
  const showLogo = !authState.accessToken
  const [downloadingBill, setDownloadingBill] = useState(false)
  const [downloadError, setDownloadError] = useState(false)
  const address = config.foi.address

  function handleDownloadBill() {
    setDownloadingBill(true)
    setDownloadError(false)

    getBillDownload(billId)
      .then(response => {
        handleDownloadResponse(response, buildBillPdfFileName(billSecondaryId), 'download')
        setDownloadingBill(false)
      })
      .catch(e => {
        console.error('An error occurred while downloading the bill', billId, e)
        setDownloadingBill(false)
        setDownloadError(true)
      })
  }

  return (
    <ActionRequiredTemplate title={`${foiSecondaryId} Awaiting Payment`} showLogo={showLogo} showContact={config.showContact}>
      <BodyText>
        <BoldSpan>Action required.</BoldSpan> Your request will not be processed until payment is completed. In person payment can be made at City
        Hall. Please ensure you bring your request number <BoldSpan>{foiSecondaryId} and a copy of your invoice</BoldSpan>. For the invoice, this can
        be either the confirmation email or a copy of the invoice printed or downloaded. The address is:
      </BodyText>
      {address && <AddressText>{address}</AddressText>}
      <SecondaryButton onClick={handleDownloadBill} loading={downloadingBill}>
        Download Invoice
      </SecondaryButton>
      {downloadError && <ErrorMessage>There was an error downloading your invoice. Please try again.</ErrorMessage>}
    </ActionRequiredTemplate>
  )
}

FOIConfirmationAwaitingPayment.propTypes = {
  foiSecondaryId: PropTypes.string.isRequired,
  billSecondaryId: PropTypes.string.isRequired,
  billId: PropTypes.string.isRequired
}

export default FOIConfirmationAwaitingPayment
